import { Stack } from '@mui/material'
import MilkInfoBlock from './components/MilkInfoBlock'

interface MilkYieldInfoProps {
	sellMilk: number | string
	rejectedMilk: number | string
}

const MilkYieldInfo = ({ sellMilk, rejectedMilk }: MilkYieldInfoProps) => {
	return (
		<Stack direction='row' gap='24px'>
			<MilkInfoBlock yieldMilk={sellMilk} description={'Товарное молоко'} />
			<MilkInfoBlock
				yieldMilk={rejectedMilk}
				description={'Бракованное молоко'}
			/>
		</Stack>
	)
}

export default MilkYieldInfo
